// These values correspond to the `kind` column in the primary database's `rpa_jobs` table.
// They are in UPPER_SNAKE_CASE due to legacy reasons, even though Flow API standards require UpperCamelCase.
export var FlowRpaJobKind;
(function (FlowRpaJobKind) {
    FlowRpaJobKind["AppointmentUpdateAggregation"] = "APPOINTMENT_UPDATE_AGGREGATION";
    FlowRpaJobKind["CalendarSync"] = "CALENDAR_SYNC";
    FlowRpaJobKind["ExportAllergies"] = "EXPORT_ALLERGIES";
    FlowRpaJobKind["ExportAppointmentNote"] = "EXPORT_APPOINTMENT_NOTE";
    FlowRpaJobKind["ExportAppointmentStatus"] = "EXPORT_APPOINTMENT_STATUS";
    FlowRpaJobKind["ExportAuthorizationForm"] = "EXPORT_AUTHORIZATION_FORM";
    FlowRpaJobKind["ExportAuthorizationStart"] = "EXPORT_AUTHORIZATION_START";
    FlowRpaJobKind["ExportAuthorizationStatus"] = "EXPORT_AUTHORIZATION_STATUS";
    FlowRpaJobKind["ExportAuthorizationStatusV2"] = "EXPORT_AUTHORIZATION_STATUS_V2";
    FlowRpaJobKind["ExportAuthorizationSubmission"] = "EXPORT_AUTHORIZATION_SUBMISSION";
    FlowRpaJobKind["ExportBilling"] = "EXPORT_BILLING";
    FlowRpaJobKind["ExportBillingGroup"] = "EXPORT_BILLING_GROUP";
    FlowRpaJobKind["ExportCareGapFindings"] = "EXPORT_CARE_GAP_FINDINGS";
    FlowRpaJobKind["ExportClinicalComment"] = "EXPORT_CLINICAL_COMMENT";
    FlowRpaJobKind["ExportDummyValues"] = "EXPORT_DUMMY_VALUES";
    FlowRpaJobKind["ExportNewEncounter"] = "EXPORT_NEW_ENCOUNTER";
    FlowRpaJobKind["ExportEncounterInformation"] = "EXPORT_ENCOUNTER_INFORMATION";
    FlowRpaJobKind["ExportEncounterPatientData"] = "EXPORT_ENCOUNTER_PATIENT_DATA";
    FlowRpaJobKind["ExportFamilyMedicalHistory"] = "EXPORT_FAMILY_MEDICAL_HISTORY";
    FlowRpaJobKind["ExportFinancialResponsibility"] = "EXPORT_FINANCIAL_RESPONSIBILITY";
    FlowRpaJobKind["ExportFindingEvidence"] = "EXPORT_FINDING_EVIDENCE";
    FlowRpaJobKind["ExportFollowUp"] = "EXPORT_FOLLOW_UP";
    FlowRpaJobKind["ExportFormOutcomes"] = "EXPORT_FORM_OUTCOMES";
    FlowRpaJobKind["ExportForms"] = "EXPORT_FORMS";
    FlowRpaJobKind["ExportGeneralComment"] = "EXPORT_GENERAL_COMMENT";
    FlowRpaJobKind["ExportGuarantors"] = "EXPORT_GUARANTORS";
    FlowRpaJobKind["ExportHccFindings"] = "EXPORT_HCC_FINDINGS";
    FlowRpaJobKind["ExportHospitalAccount"] = "EXPORT_HOSPITAL_ACCOUNT";
    FlowRpaJobKind["ExportMarkAsReviewed"] = "EXPORT_MARK_AS_REVIEWED";
    FlowRpaJobKind["ExportMedications"] = "EXPORT_MEDICATIONS";
    FlowRpaJobKind["ExportMspqForm"] = "EXPORT_MSPQ_FORM";
    FlowRpaJobKind["ExportNote"] = "EXPORT_NOTE";
    FlowRpaJobKind["ExportNoteCheckedIn"] = "EXPORT_NOTE_CHECKED_IN";
    FlowRpaJobKind["ExportNoticeOfAdmission"] = "EXPORT_NOTICE_OF_ADMISSION";
    FlowRpaJobKind["ExportNoticeOfAdmissionStatus"] = "EXPORT_NOTICE_OF_ADMISSION_STATUS";
    FlowRpaJobKind["ExportOrderRequestListStatus"] = "EXPORT_ORDER_REQUEST_LIST_STATUS";
    FlowRpaJobKind["ExportOrders"] = "EXPORT_ORDERS";
    FlowRpaJobKind["ExportPatientCareProviders"] = "EXPORT_PATIENT_CARE_PROVIDERS";
    FlowRpaJobKind["ExportPatientInformation"] = "EXPORT_PATIENT_INFORMATION";
    FlowRpaJobKind["ExportPatientInsuranceInformation"] = "EXPORT_PATIENT_INSURANCE_INFORMATION";
    FlowRpaJobKind["ExportPatientMedicalHistory"] = "EXPORT_PATIENT_MEDICAL_HISTORY";
    FlowRpaJobKind["ExportPatientOutreaches"] = "EXPORT_PATIENT_OUTREACHES";
    FlowRpaJobKind["ExportPatientPharmacies"] = "EXPORT_PATIENT_PHARMACIES";
    FlowRpaJobKind["ExportPatientUploads"] = "EXPORT_PATIENT_UPLOADS";
    FlowRpaJobKind["ExportPatientUploadStatuses"] = "EXPORT_PATIENT_UPLOAD_STATUSES";
    FlowRpaJobKind["ExportPayorAuthorization"] = "EXPORT_PAYOR_AUTHORIZATION";
    FlowRpaJobKind["ExportPrenatalFlowsheet"] = "EXPORT_PRENATAL_FLOWSHEET";
    FlowRpaJobKind["ExportPreregistrationEncounter"] = "EXPORT_PREREGISTRATION_ENCOUNTER";
    FlowRpaJobKind["ExportPrevisitPlanning"] = "EXPORT_PREVISIT_PLANNING";
    FlowRpaJobKind["ExportProcessedPayments"] = "EXPORT_PROCESSED_PAYMENTS";
    FlowRpaJobKind["ExportProcessedRefunds"] = "EXPORT_PROCESSED_REFUNDS";
    FlowRpaJobKind["ExportQualityMeasures"] = "EXPORT_QUALITY_MEASURES";
    FlowRpaJobKind["ExportReferralDocument"] = "EXPORT_REFERRAL_DOCUMENT";
    FlowRpaJobKind["ExportReferralOrder"] = "EXPORT_REFERRAL_ORDER";
    FlowRpaJobKind["ExportRegistrationNote"] = "EXPORT_REGISTRATION_NOTE";
    FlowRpaJobKind["ExportReviewClinicalAdvisories"] = "EXPORT_REVIEW_CLINICAL_ADVISORIES";
    FlowRpaJobKind["ExportScheduledAppointment"] = "EXPORT_SCHEDULED_APPOINTMENT";
    FlowRpaJobKind["ExportScheduledOrderAssociation"] = "EXPORT_SCHEDULED_ORDER_ASSOCIATION";
    FlowRpaJobKind["ExportSocialHistory"] = "EXPORT_SOCIAL_HISTORY";
    FlowRpaJobKind["ExportSurgicalHistory"] = "EXPORT_SURGICAL_HISTORY";
    FlowRpaJobKind["ExportTerminatedInsurances"] = "EXPORT_TERMINATED_INSURANCES";
    FlowRpaJobKind["ExportVerifyRegistration"] = "EXPORT_VERIFY_REGISTRATION";
    FlowRpaJobKind["ExtractAllergies"] = "EXTRACT_ALLERGIES";
    FlowRpaJobKind["ExtractAuthorizationStatus"] = "EXTRACT_AUTHORIZATION_STATUS";
    FlowRpaJobKind["ExtractBilling"] = "EXTRACT_BILLING";
    FlowRpaJobKind["ExtractCareGapFindings"] = "EXTRACT_CARE_GAP_FINDINGS";
    FlowRpaJobKind["ExtractCareGapStatuses"] = "EXTRACT_CARE_GAP_STATUSES";
    FlowRpaJobKind["ExtractCarryCurrent"] = "EXTRACT_CARRY_CURRENT";
    FlowRpaJobKind["ExtractCarryForward"] = "EXTRACT_CARRY_FORWARD";
    FlowRpaJobKind["ExtractDiagmedProblemGroups"] = "EXTRACT_DIAGMED_PROBLEM_GROUPS";
    FlowRpaJobKind["ExtractEncounterInformation"] = "EXTRACT_ENCOUNTER_INFORMATION";
    FlowRpaJobKind["ExtractEncounterPatientData"] = "EXTRACT_ENCOUNTER_PATIENT_DATA";
    FlowRpaJobKind["ExtractFamilyMedicalHistory"] = "EXTRACT_FAMILY_MEDICAL_HISTORY";
    FlowRpaJobKind["ExtractGuarantors"] = "EXTRACT_GUARANTORS";
    FlowRpaJobKind["ExtractHistoricalPatientEncounters"] = "EXTRACT_HISTORICAL_PATIENT_ENCOUNTERS";
    FlowRpaJobKind["ExtractImmunizationRegistry"] = "EXTRACT_IMMUNIZATION_REGISTRY";
    FlowRpaJobKind["ExtractInterpretations"] = "EXTRACT_INTERPRETATIONS";
    FlowRpaJobKind["ExtractLabValues"] = "EXTRACT_LAB_VALUES";
    FlowRpaJobKind["ExtractMedicalNecessity"] = "EXTRACT_MEDICAL_NECESSITY";
    FlowRpaJobKind["ExtractMedications"] = "EXTRACT_MEDICATIONS";
    FlowRpaJobKind["ExtractMspqForm"] = "EXTRACT_MSPQ_FORM";
    FlowRpaJobKind["ExtractNoticeOfAdmissionStatus"] = "EXTRACT_NOTICE_OF_ADMISSION_STATUS";
    FlowRpaJobKind["ExtractOrders"] = "EXTRACT_ORDERS";
    FlowRpaJobKind["ExtractOutstandingBalances"] = "EXTRACT_OUTSTANDING_BALANCES";
    FlowRpaJobKind["ExtractPatientAdvisories"] = "EXTRACT_PATIENT_ADVISORIES";
    FlowRpaJobKind["ExtractPatientAdvisoryDocuments"] = "EXTRACT_PATIENT_ADVISORY_DOCUMENTS";
    FlowRpaJobKind["ExtractPatientCareProviders"] = "EXTRACT_PATIENT_CARE_PROVIDERS";
    FlowRpaJobKind["ExtractPatientCommunicationConsent"] = "EXTRACT_PATIENT_COMMUNICATION_CONSENT";
    FlowRpaJobKind["ExtractPatientDocuments"] = "EXTRACT_PATIENT_DOCUMENTS";
    FlowRpaJobKind["ExtractPatientEligibility"] = "EXTRACT_PATIENT_ELIGIBILITY";
    FlowRpaJobKind["ExtractPatientInformation"] = "EXTRACT_PATIENT_INFORMATION";
    FlowRpaJobKind["ExtractPatientInsuranceRteInformation"] = "EXTRACT_PATIENT_INSURANCE_RTE_INFORMATION";
    FlowRpaJobKind["ExtractPatientMedicalHistory"] = "EXTRACT_PATIENT_MEDICAL_HISTORY";
    FlowRpaJobKind["ExtractPatientOrder"] = "EXTRACT_PATIENT_ORDER";
    FlowRpaJobKind["ExtractPatientPharmacies"] = "EXTRACT_PATIENT_PHARMACIES";
    FlowRpaJobKind["ExtractPatientProblems"] = "EXTRACT_PATIENT_PROBLEMS";
    FlowRpaJobKind["ExtractPatientUploads"] = "EXTRACT_PATIENT_UPLOADS";
    FlowRpaJobKind["ExtractPayorAuthorizationStatus"] = "EXTRACT_PAYOR_AUTHORIZATION_STATUS";
    FlowRpaJobKind["ExtractPredictBillingData"] = "EXTRACT_PREDICT_BILLING_DATA";
    FlowRpaJobKind["ExtractPreferredPharmacy"] = "EXTRACT_PREFERRED_PHARMACY";
    FlowRpaJobKind["ExtractPregnancy"] = "EXTRACT_PREGNANCY";
    FlowRpaJobKind["ExtractQualityMeasures"] = "EXTRACT_QUALITY_MEASURES";
    FlowRpaJobKind["ExtractSocialHistory"] = "EXTRACT_SOCIAL_HISTORY";
    FlowRpaJobKind["ExtractSurgicalHistory"] = "EXTRACT_SURGICAL_HISTORY";
    FlowRpaJobKind["ExtractUpcomingPatientInsurance"] = "EXTRACT_UPCOMING_PATIENT_INSURANCE";
    FlowRpaJobKind["ExtractUpcomingPregnancy"] = "EXTRACT_UPCOMING_PREGNANCY";
    FlowRpaJobKind["ExtractVitals"] = "EXTRACT_VITALS";
    FlowRpaJobKind["OutreachSync"] = "OUTREACH_SYNC";
    FlowRpaJobKind["PatientListSync"] = "PATIENT_LIST_SYNC";
    FlowRpaJobKind["PatientOrdersSync"] = "PATIENT_ORDERS_SYNC";
    FlowRpaJobKind["Reckon"] = "RECKON";
})(FlowRpaJobKind || (FlowRpaJobKind = {}));
export var FlowRpaJobSuccessFilter;
(function (FlowRpaJobSuccessFilter) {
    FlowRpaJobSuccessFilter["All"] = "All";
    FlowRpaJobSuccessFilter["FailedOnly"] = "FailedOnly";
    FlowRpaJobSuccessFilter["SuccessOnly"] = "SuccessOnly";
})(FlowRpaJobSuccessFilter || (FlowRpaJobSuccessFilter = {}));
//# sourceMappingURL=rpaJob.js.map